import { AdjacentLocationType } from 'features/Location/services/adjacentHub'

// The list API can return placeholder entries ({ location_id: 0, location_name: "" }); drop them.
export const getValidAdjacentLocations = (locations: AdjacentLocationType[] = []) =>
  locations.filter(({ location_id }) => location_id > 0)

// location ID -> name map for the shared adjacentHubList name cache.
export const toAdjacentLocationNameMap = (locations: AdjacentLocationType[] = []) =>
  Object.fromEntries(
    getValidAdjacentLocations(locations).map(({ location_id, location_name }) => [
      location_id,
      location_name,
    ]),
  )
